import _ from "lodash";
import { inject, observer } from "mobx-react";
import { isObservableArray } from "mobx";
import moment from "moment-timezone";
import React from "react";
import MaterialButton from "@material-ui/core/Button";
import Card from "@material-ui/core/Card";
import CardHeader from "@material-ui/core/CardHeader";
import CardMedia from "@material-ui/core/CardMedia";
import CardActions from "@material-ui/core/CardActions";
import IconButton from "@material-ui/core/IconButton";
import CardContent from "@material-ui/core/CardContent";
import Typography from "@material-ui/core/Typography";
import AddToQueue from "@material-ui/icons/AddToQueue";
import EditIcon from "@material-ui/icons/Edit";
import ReportProblem from "@material-ui/icons/ReportProblem";
import FeedTypeMenu from "components/FeedTypeMenu";
import Tooltip from "@material-ui/core/Tooltip";
import VideoPlaceholder from "components/VideoPlaceholder";
import { CloudUpload } from "@material-ui/icons";

const feedTypeTitle = feedType => {
  switch (feedType) {
    case "HOME":
      return "Home";
    case "AWAY":
      return "Away";
    case "NETWORK":
      return "Network";
    case "WORLD":
      return "World";
    case "THREE_D_VIZ":
      return "3D Viz";
    case "CMS":
      return "CMS";
    default:
      return "Video Not Available";
  }
};

const clipDate = play => {
  if (play.get("gameDate")) {
    return moment(play.get("gameDate")).format("MMMM D, YYYY");
  }

  const timestamp = play.get("fields").find(f => f.name === "Timestamp");
  return timestamp
    ? moment(timestamp.value).format("MMMM D, YYYY")
    : "Unknown date";
};

class Play extends React.Component {
  constructor(props) {
    super(props);
    this.formatFields(props.play.get("fields"));
    this.createCustomClip = this.createCustomClip.bind(this);
  }

  getFieldDisplayValue(fieldName, value, displayValue) {
    return displayValue !== value
      ? `${fieldName} : ${displayValue} (${value})`
      : `${fieldName} : ${value}`;
  }

  formatFields(fields) {
    fields.forEach(field => {
      if (field.name === "PitchTime") {
        field.value = `${moment(field.value)
          .tz("America/New_York")
          .format("h:mm:ss A z")}`;
      }
      if (isObservableArray(field.value)) {
        field.value = field.value.join(", ");
      }
    });
  }

  getThumbnail(play) {
    const feeds = play.get("videos");
    const selectedFeedType = play.get("feedType");
    if (feeds.length && selectedFeedType) {
      const currentFeed = feeds.find(
        feed => feed.feedType === selectedFeedType
      );
      const thumbnail = currentFeed.image;
      if (thumbnail && thumbnail.cuts.length) {
        return thumbnail.cuts[0].at2x;
      }
    }
  }

  createCustomClip() {
    const { play, createCustomClipStore, routerStore } = this.props;

    createCustomClipStore.getPlayInfo(play.get("id")).then(playInfo => {
      const playStart = _.find(playInfo, f => f.name === "StartTime");
      const playEnd = _.find(playInfo, f => f.name === "EndTime");
      const clipUrl = `/custom-clips?gamePk=${play.get("gamePk")}&startTime=${
        playStart.value
      }&endTime=${playEnd.value}&feed=${play.get("feedType")}&date=${play.get(
        "gameDate"
      )}`;
      routerStore.history.push(clipUrl);
    });
  }

  sendToForge() {
    const { play, quickerClipStore } = this.props;
    quickerClipStore.openDialog(play);
  }

  addToReel() {
    const { play, reelStore } = this.props;

    if (play.get("feedType") === "CMS") {
      reelStore.addVideo({
        url: play.get("videoSrc"),
        thumbnail: this.getThumbnail(play)
      });
    } else {
      reelStore.addPlay(play.get("id"));
    }
  }

  render() {
    const {
      play,
      videoSearchStore,
      videoPlayerStore,
      issueDialogStore,
      authStore,
      query
    } = this.props;

    const hasVideo = _.isEmpty(play.get("videoSrc")) ? false : true;
    const researchLink = _.find(play.get("links"), l => l.rel === "research");
    const showResearchTool = authStore.canAccessResearchTool && researchLink;
    const thumbnail = this.getThumbnail(play);

    return (
      <Card>
        <CardHeader
          action={
            hasVideo ? (
              <FeedTypeMenu
                playId={play.get("id")}
                videos={play.get("videos")}
                selected={play.get("feedType")}
                store={videoSearchStore}
              />
            ) : null
          }
          titleTypographyProps={{ variant: "h6" }}
          title={feedTypeTitle(play.get("feedType"))}
          subheader={clipDate(play)}
        />
        {thumbnail ? (
          <CardMedia component="img" src={thumbnail} />
        ) : (
          <VideoPlaceholder />
        )}
        <CardContent style={{ maxHeight: "200px", overflow: "scroll" }}>
          <Typography style={{ fontSize: "0.8rem" }} component="p">
            {play.get("description")}
          </Typography>
          {play.get("fields").length === 0 ? null : <br />}
          {play.get("fields").map((f, i) => (
            <Typography
              key={i}
              style={{ fontSize: "0.8rem" }}
              component="p"
              color="textSecondary"
            >
              {this.getFieldDisplayValue(f.name, f.value, f.displayValue)}
            </Typography>
          ))}
        </CardContent>
        <CardActions disableSpacing>
          {hasVideo ? (
            <React.Fragment>
              <Tooltip title="Add to reel">
                <IconButton onClick={() => this.addToReel()}>
                  <AddToQueue />
                </IconButton>
              </Tooltip>
              <MaterialButton
                size="small"
                color="primary"
                onClick={() =>
                  videoPlayerStore.showVideoSrc(play.get("videoSrc"))
                }
              >
                Watch
              </MaterialButton>
            </React.Fragment>
          ) : null}
          {showResearchTool && (
            <MaterialButton
              size="small"
              color="primary"
              href={researchLink.href}
              target="_blank"
            >
              Research
            </MaterialButton>
          )}
          <IconButton
            onClick={() =>
              issueDialogStore.open({
                feedType: play.get("feedType"),
                gamePk: play.get("gamePk"),
                playId: play.get("id"),
                query
              })
            }
          >
            <ReportProblem />
          </IconButton>
          {play.get("feedType") !== "CMS" && (
            <Tooltip title="Create custom clip">
              <IconButton onClick={() => this.createCustomClip()}>
                <EditIcon />
              </IconButton>
            </Tooltip>
          )}
          {authStore.canSendToForge && <Tooltip title="Send to Forge">
            <IconButton onClick={() => this.sendToForge()}>
              <CloudUpload />
            </IconButton>
          </Tooltip>}
        </CardActions>
      </Card>
    );
  }
}

export default inject(
  "videoSearchStore",
  "reelStore",
  "videoPlayerStore",
  "issueDialogStore",
  "createCustomClipStore",
  "routerStore",
  "authStore",
  "quickerClipStore"
)(observer(Play));



// WEBPACK FOOTER //
// ./src/components/Play.js